import * as actionTypes from 'constants/ActionTypes';

const companies = (state = {
    items: [],
    isLoaded: false,
}, action) => {
    switch (action.type) {
        case actionTypes.GET_COMPANIES.REQUEST:
            return {
                ...state,
            };
        case actionTypes.GET_COMPANIES.SUCCESS: {
            return {
                ...state,
                items: action.data,
                isLoaded: true,
            };
        }
        case actionTypes.GET_COMPANIES.FAILURE:
            return {
                ...state,
                isLoaded: true,
            };

        default:
            return state;
    }
};

export default companies;



// WEBPACK FOOTER //
// ./app/reducers/companies.js